export default __webpack_public_path__ + "static/282-03fd26021d3863c9254be6e42cedff14.gif";